import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Fade } from 'react-awesome-reveal';

// --- STYLED COMPONENTS ---

const PageWrapper = styled.div`
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  max-width: 1200px;
  margin: 0 auto;
  padding: 10px 20px;
  background-color: #f8fafc;
`;

const HeaderSection = styled.header`
  text-align: center;
  margin-bottom: 10px;
`;

const PageTitle = styled.h1`
  font-size: 2.5rem;
  font-weight: 700;
  color: #439E6D; /* Custom requested text title color */
  text-transform: uppercase;
//   margin-bottom: 10px;
  letter-spacing: 0.5px;
`;

const Subtitle = styled.p`
  font-size: 1.1rem;
  color: #64748b;
  margin: 0;
`;

const NewsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

const NewsCard = styled.a`
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
  text-decoration: none;
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  cursor: pointer;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }
`;

const ImageWrapper = styled.div`
  width: 100%;
  height: 200px;
  overflow: hidden;
  background-color: #e2e8f0;
`;

const CardImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;

  ${NewsCard}:hover & {
    transform: scale(1.05);
  }
`;

const CardBody = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

const NewsSource = styled.span`
  font-size: 0.75rem;
  text-transform: uppercase;
  font-weight: 700;
  color: #439E6D; /* Theme accent matching headers */
  margin-bottom: 8px;
  letter-spacing: 0.5px;
`;

const CardTitle = styled.h3`
  font-size: 1.3rem;
  font-weight: 600;
  color: #0c2340; /* Dark corporate navy blue */
  margin: 0 0 10px 0;
  line-height: 1.4;
  
  /* Fallback text clamp for tidy vertical alignments */
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const CardExcerpt = styled.p`
  font-size: 1.1rem;
  color: #4a5568;
  line-height: 1.5;
  margin: 0 0 15px 0;
  flex-grow: 1;

  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const CardFooter = styled.div`
  font-size: 0.8rem;
  color: #94a3b8;
  border-top: 1px solid #f1f5f9;
  padding-top: 12px;
  margin-top: auto;
`;

const LoadingSpinner = styled.div`
  text-align: center;
  font-size: 1.2rem;
  color: #439E6D;
  padding: 100px 0;
  font-weight: 600;
`;

// --- MAIN COMPONENT ---

const NewsPage = () => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     // Generates 30 clean data models to pop standard presentation fields immediately
//     const fetchNewsData = async () => {
//       try {
//         setLoading(true);
//         const tempArticles = Array.from({ length: 30 }).map((_, index) => {
//           const id = index + 1;
//           return {
//             id,
//             title: `Global Infrastructure Development & Emerging Market Expansion Update Vol. ${id}`,
//             description: "Industry leaders align operational targets with sustainable infrastructure solutions, optimizing talent frameworks and resource efficiency to expand corporate value delivery footprints.",
//             source: id % 2 === 0 ? "Reuters Business" : "Bloomberg Global",
//             publishedAt: new Date(Date.now() - id * 3600000).toLocaleDateString(undefined, {
//               month: 'short', day: 'numeric', year: 'numeric'
//             }),
//             url: "https://news.google.com", // Target URL that opens in a new tab
//             imageUrl: `https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&q=80&w=400&sig=${id}`
//           };
//         });

//         // Simulating network latency for realistic loader response
//         setTimeout(() => {
//           setArticles(tempArticles);
//           setLoading(false);
//         }, 600);

//       } catch (error) {
//         console.error("Error formatting news context:", error);
//         setLoading(false);
//       }
//     };

//     fetchNewsData();
//   }, []);


useEffect(() => {
  const fetchNewsData = async () => {
    setLoading(true);

    const liveArticles = [
      {
        id: 1,
        title: "Oil prices steady amid global supply concerns",
        description: "Global crude oil markets remain stable as investors monitor supply chain risks and production levels.",
        source: "Reuters",
        publishedAt: "Today",
        url: "https://www.reuters.com/business/energy/",
imageUrl: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=800&q=80"
      },
      {
        id: 2,
        title: "Energy transition accelerates in global markets",
        description: "Oil and gas companies continue investing in renewable energy and low-carbon technologies.",
        source: "Bloomberg",
        publishedAt: "Today",
        url: "https://www.bloomberg.com/energy",
        imageUrl: "https://images.unsplash.com/photo-1509391366360-2e959784a276?auto=format&fit=crop&w=800&q=80"
      },
      {
        id: 3,
        title: "Offshore drilling technology sees major upgrades",
        description: "New innovations are improving efficiency and safety in offshore oil exploration.",
        source: "CNBC",
        publishedAt: "Today",
        url: "https://www.cnbc.com/energy/",
       imageUrl: "https://images.unsplash.com/photo-1581092580497-e0d23cbdf1dc?auto=format&fit=crop&w=800&q=80"
      },
      {
  id: 4,
  title: "Global LNG demand rises sharply in 2026 forecast",
  description: "Liquefied natural gas demand is expected to grow across Europe and Asia.",
  source: "Reuters",
  publishedAt: "Today",
  url: "https://www.reuters.com/business/energy/",
  imageUrl: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&w=800&q=80"
},
{
  id: 5,
  title: "West Africa expands oil production capacity",
  description: "New oil field developments are boosting regional output and exports.",
  source: "Al Jazeera",
  publishedAt: "Today",
  url: "https://www.aljazeera.com/economy/",
  imageUrl: "https://images.unsplash.com/photo-1521295121783-8a321d551ad2?auto=format&fit=crop&w=800&q=80"
},
{
  id: 6,
  title: "Refinery modernization projects increase output",
  description: "Upgraded refining infrastructure is improving efficiency in global oil markets.",
  source: "Financial Times",
  publishedAt: "Today",
  url: "https://www.ft.com/energy",
  imageUrl: "https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?auto=format&fit=crop&w=800&q=80"
},
      {
        id: 7,
        title: "Geopolitical tensions impact energy markets",
        description: "Oil traders respond to shifting geopolitical developments affecting supply routes.",
        source: "BBC News",
        publishedAt: "Today",
        url: "https://www.bbc.com/news/business",
        imageUrl: "https://images.unsplash.com/photo-1531973576160-7125cd663d86?auto=format&fit=crop&w=800&q=80"
      },
      {
        id: 8,
        title: "AI adoption increases in oil and gas sector",
        description: "Companies are using AI for predictive maintenance and operational optimization.",
        source: "TechCrunch",
        publishedAt: "Today",
        url: "https://techcrunch.com/",
        imageUrl: "https://images.unsplash.com/photo-1555949963-aa79dcee981c?auto=format&fit=crop&w=800&q=80"
      },
      {
        id: 9,
        title: "New offshore safety regulations introduced",
        description: "Regulators enforce stricter safety measures for offshore oil platforms.",
        source: "Reuters",
        publishedAt: "Today",
        url: "https://www.reuters.com/world/",
        imageUrl: "https://images.unsplash.com/photo-1529070538774-1843cb3265df?auto=format&fit=crop&w=800&q=80"
      },
      {
        id: 10,
        title: "Energy companies invest heavily in infrastructure",
        description: "Global oil firms increase spending on pipelines and storage facilities.",
        source: "Bloomberg",
        publishedAt: "Today",
        url: "https://www.bloomberg.com/energy",
        imageUrl: "https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?auto=format&fit=crop&w=800&q=80"
      }
    ];

    setTimeout(() => {
      setArticles(liveArticles);
      setLoading(false);
    }, 500);
  };

  fetchNewsData();
}, []);

  if (loading) {
    return <LoadingSpinner>Loading Latest News Headlines...</LoadingSpinner>;
  }

  return (
    <PageWrapper>
      <HeaderSection>
        <Fade triggerOnce direction="up" duration={800}>
          <PageTitle>Latest Corporate News</PageTitle>
          <Subtitle>Stay updated with international operational updates and industry analytics</Subtitle>
        </Fade>
      </HeaderSection>

      <NewsGrid>
        <Fade triggerOnce cascade direction="up" duration={500} fraction={0.05} damping={0.1}>
          {articles.map((article) => (
            <NewsCard 
              key={article.id} 
              href={article.url} 
              target="_blank" 
              rel="noopener noreferrer"
            >
              <ImageWrapper>
                <CardImage src={article.imageUrl} alt={article.title} />
              </ImageWrapper>
              
              <CardBody>
                <NewsSource>{article.source}</NewsSource>
                <CardTitle>{article.title}</CardTitle>
                <CardExcerpt>{article.description}</CardExcerpt>
                <CardFooter>{article.publishedAt}</CardFooter>
              </CardBody>
            </NewsCard>
          ))}
        </Fade>
      </NewsGrid>
    </PageWrapper>
  );
};

export default NewsPage;